import { render, staticRenderFns } from "./LinkQR013.vue?vue&type=template&id=1cbc3a0b&scoped=true&"
import script from "./LinkQR013.vue?vue&type=script&lang=js&"
export * from "./LinkQR013.vue?vue&type=script&lang=js&"
import style0 from "./LinkQR013.vue?vue&type=style&index=0&id=1cbc3a0b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbc3a0b",
  null
  
)

export default component.exports